export const useLoginState = ({
  orderId,
  setOrderId,
  customerEmail,
  setCustomerEmail,
  setLoginSuccess,
}) => {
  const isDisableCTA = orderId === "" || customerEmail === "";
  const resetLoginState = () => {
    setOrderId("");
    setCustomerEmail("");
    setLoginSuccess(false);
  };
  return {
    isDisableCTA,
    resetLoginState,
  };
};
